import { Pipe, PipeTransform } from '@angular/core';

// Update this hash whenever icons-sprite.svg changes to bust browser/webview caches.
// Generate with: md5 -q src/assets/images/icons-sprite.svg | cut -c1-8
const SPRITE_HASH = 'ce89f7d8';
export const ICONS_SPRITE_PATH = `./assets/images/icons-sprite.svg?v=${SPRITE_HASH}`;

@Pipe({ name: 'spriteIcon' })
export class SpriteIconPipe implements PipeTransform {
  transform(iconId: string): string {
    return `${ICONS_SPRITE_PATH}#${iconId}`;
  }
}
